export default __webpack_public_path__ + "static/media/logo-big.3d40e0ec.png";